import { Component, Input, OnInit } from '@angular/core';

import { Rating } from '../../../../../canvas/components/sustainability-rating/rating/rating';
import { TraditionalRatingService } from '../../../../../canvas/components/sustainability-rating/rating/traditional-rating.service';

@Component({
  selector: 'app-capacity-scanning',
  templateUrl: './capacity-scanning.component.html',
  styleUrls: ['./capacity-scanning.component.css']
})
export class CapacityScanningComponent implements OnInit {

  @Input() onShowPeriod;
  windowWith;

  mockRatings: Rating [];
  ratings: Rating [];
  merged = [].concat.apply([], this.ratings);

  constructor(
    private _traditionalRatingService: TraditionalRatingService
  ) {}

  getMockRatings(): void {
    this._traditionalRatingService.getMockRatings().then(mockRatings => this.mockRatings = mockRatings);
  }

  getRatings(): void {
    this._traditionalRatingService.getRatings().then(ratings => this.ratings = ratings);
  }

  ngOnInit(): void {
    this.windowWith = window.innerWidth;
    this.getMockRatings();
    this.getRatings();
    console.log('testing' + this.merged);
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
  }

  breakRow(theArr: any[]) {
    const arrOfarr = [];
    if (this.windowWith > 768) {
      for (let i = 0; i < theArr.length ; i+=3) {
        const row = [];
        for (let x = 0; x < 3; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else if (this.windowWith > 480) {
      for (let i = 0; i < theArr.length ; i+=2) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 2; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else {
      for (let i = 0; i < theArr.length ; i+=1) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 1; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/tomorrow/components/capacity-scanning/capacity-scanning.component.ts